
import axiosInstance from "../utils/axios-instance";


export const getLinkedAccountInfo = async (id) => {
    try {
        const response = await axiosInstance.get(`/account/${id}`);

        return response.data
    } catch (err) {
        return err.data
    }
}

export const getMyCardAmounts = async (id) =>    {
    try {
        const response = await axiosInstance.get(`/account/${id}/amounts/`)
        return response.data
    } catch (err) {
       return err.data
    }
}

export const getMyAutoPayCardInfo = async (id) => {
    try{
        const response = await axiosInstance.get(`/autopay/${id}`);
        return response.data
    } catch (err){
        return err.data
    }
}

